import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import { cloneDeep, isEmpty, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { assetType as assetTypeOptions, checkArray, cloneData, createOptions, fileTypeOptions } from '../../../../Components/helper';
import * as action from './store/DamFolder.action';
import { getCategory3Details, getCategory4Details } from '../../../SystemMasters/Store/SystemMasters.action';
import { useDamProductFolderModuleState } from './Provider';
import * as actions from '../DamFiles/store/DamFile.action';

function DamFolderFilesFilter({ folderId }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const [isApply, setIsApply] = useState(false);
  const [state, setState] = useState({
    dropdownOptions: [],
  });
  const { dropdownOptions } = state;
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    ColorLibraryDetails,
    damModule: { damTagList },
    damProductFolderModule: {
      fileFilterValues: {
        colourTheme,
        primaryColour,
        secondaryColour,
        folder,
        fileType,
        assetType,
        productType,
        brand,
        gradingGroups,
        category1,
        category2,
        category3,
        category4,
        dynamicDropdown,
        tags,
      },
      damProductFolderList,
    },
    damProductFileModule: { folderOptions },
    UserDetails: {
      userInfo: { userId },
    },
    SystemMastersDetails,
    PomDetails,
  } = reducer;
  const { ColorWaysLibList } = ColorLibraryDetails;
  const { GradingList } = PomDetails;
  const { damAttributeDropdownList } = SystemMastersDetails;
  const { brandList, category1List, category2List, pcTypeList, category3List, category4List } = SystemMastersDetails;
  const { setDamFolderState } = useDamProductFolderModuleState([]);

  useEffect(() => {
    const callfn = async () => {
      await dispatch(actions.fetchProductDamTag());
    };
    callfn();
  }, [dispatch]);

  const colourThemeOptions = useMemo(() => {
    if (checkArray(ColorWaysLibList)) return createOptions(ColorWaysLibList, 'name', '_id');
    return [];
  }, [ColorWaysLibList]);

  const folderOptionsList = useMemo(() => {
    if (checkArray(folderOptions)) return createOptions(folderOptions, 'name', '_id');
    return [];
  }, [folderOptions]);

  const productTypeOptions = useMemo(() => {
    if (checkArray(pcTypeList)) return createOptions(pcTypeList, 'name', '_id');
    return [];
  }, [pcTypeList]);

  const brandOptions = useMemo(() => {
    if (checkArray(brandList)) return createOptions(brandList, 'name', '_id');
    return [];
  }, [brandList]);

  const gradingGroupsOptions = useMemo(() => {
    if (checkArray(GradingList)) return createOptions(GradingList, 'name', '_id');
    return [];
  }, [GradingList]);

  const category1Options = useMemo(() => {
    if (checkArray(category1List)) return createOptions(category1List, 'name', '_id');
    return [];
  }, [category1List]);

  const category2Options = useMemo(() => {
    if (checkArray(category2List)) return createOptions(category2List, 'name', '_id');
    return [];
  }, [category2List]);

  const category3Options = useMemo(() => {
    if (checkArray(category3List)) return createOptions(category3List, 'name', '_id');
    return [];
  }, [category3List]);

  const category4Options = useMemo(() => {
    if (checkArray(category4List)) return createOptions(category4List, 'name', '_id');
    return [];
  }, [category4List]);

  const tagsList = useMemo(() => {
    if (checkArray(damTagList)) return createOptions(damTagList, 'name', '_id');
    return [];
  }, [damTagList?.length]);

  useEffect(() => {
    if (Array.isArray(damAttributeDropdownList) && damAttributeDropdownList.length > 0) {
      const copyState = cloneData(state);
      const cloneFolderOptions = cloneData(damAttributeDropdownList);
      cloneFolderOptions.forEach((label) => {
        label.options.forEach((option) => {
          option.label = option.keyName;
          option.value = option.keyName;
        });
      });
      set(copyState, 'dropdownOptions', cloneFolderOptions);
      setState((prevState) => ({
        ...prevState,
        ...copyState,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [damAttributeDropdownList]);

  useEffect(() => {
    if (checkArray(category1) && checkArray(category2) && userId) {
      dispatch(
        getCategory3Details({
          categoryOneId: category1,
          categoryTwoId: category2,
          categoryType: 3,
          isActive: true,
          loggedInUserId: userId,
        }),
      );
    }
  }, [category1, category2, dispatch, userId]);

  useEffect(() => {
    if (checkArray(category1) && checkArray(category2) && checkArray(category3) && userId) {
      dispatch(
        getCategory4Details({
          categoryOneId: category1,
          categoryTwoId: category2,
          categoryThreeId: category3,
          categoryType: 4,
          isActive: true,
          loggedInUserId: userId,
        }),
      );
    }
  }, [category1, category2, category3, dispatch, userId]);

  const handleInputChange = async (value, name) => {
    const obj = {};
    set(obj, `${name}`, value);
    await dispatch(action.filterDamFolderFilesSortData(obj));
  };

  const handleFilterDynamicSelect = async (items, colId) => {
    const isColDataExist = dynamicDropdown?.filter((e) => e.colId === colId);
    const copyState = cloneDeep(dynamicDropdown);
    if (checkArray(isColDataExist)) {
      isColDataExist.forEach((ele) => {
        copyState.splice(
          copyState.findIndex((e) => e.valId === ele.valId),
          1,
        );
      });
    }
    const value =
      checkArray(items) &&
      items.map((valId) => {
        return { colId, valId };
      });

    const obj = {};
    if (value) {
      set(obj, 'dynamicDropdown', [...copyState, ...value]);
    } else {
      set(obj, 'dynamicDropdown', [...copyState]);
    }
    await dispatch(action.filterDamFolderFilesSortData(obj));
  };

  const handleFilterApply = async () => {
    const obj = {
      fileType,
      colourTheme,
      primaryColour,
      secondaryColour,
      folder,
      assetType,
      productType,
      brand,
      gradingGroups,
      category1,
      category2,
      category3,
      category4,
      dynamicDropdown,
      tags,
    };

    const res = {};
    setIsApply(true);
    if (devOrderId) {
      obj.devOrderId = devOrderId;
    }
    const cloneFolderList = cloneDeep(damProductFolderList);
    const selectFolderData = cloneFolderList.find((folder) => folder._id === folderId);

    let filteredFiles = selectFolderData.productFiles;

    if (!isEmpty(obj.fileType)) {
      filteredFiles = filteredFiles.filter((file) => obj.fileType.includes(file.fileType));
    }
    if (!isEmpty(obj.colourTheme)) {
      filteredFiles = filteredFiles.filter((file) => obj.colourTheme.includes(file.colourTheme));
    }
    if (!isEmpty(obj.primaryColour)) {
      filteredFiles = filteredFiles.filter((file) => obj.primaryColour.includes(file.primaryColour));
    }
    if (!isEmpty(obj.secondaryColour)) {
      filteredFiles = filteredFiles.filter((file) => obj.secondaryColour.includes(file.secondaryColour));
    }
    if (!isEmpty(obj.folder)) {
      filteredFiles = filteredFiles.filter((file) => obj.folder.some((folderId) => file.folderIds.includes(folderId)));
    }
    if (!isEmpty(obj.assetType)) {
      filteredFiles = filteredFiles.filter((file) => obj.assetType.includes(file.assetType));
    }
    if (!isEmpty(obj.dynamicDropdown)) {
      obj.dynamicDropdown.forEach((dynamicFilter) => {
        filteredFiles = filteredFiles.filter((file) =>
          file.dynamicDropdown.some((dropdown) => dropdown.optionId === dynamicFilter.valId && dropdown.lableId === dynamicFilter.colId),
        );
      });
    }
    if (!isEmpty(obj.productType)) {
      filteredFiles = filteredFiles.filter((file) => obj.productType.includes(file.devOrderId.supplierType));
    }
    if (!isEmpty(obj.brand)) {
      filteredFiles = filteredFiles.filter((file) => obj.brand.includes(file.devOrderId.brandId));
    }
    if (!isEmpty(obj.category1)) {
      filteredFiles = filteredFiles.filter((file) => obj.category1.includes(file.devOrderId.catOneId));
    }
    if (!isEmpty(obj.category2)) {
      filteredFiles = filteredFiles.filter((file) => obj.category2.includes(file.devOrderId.catTwoId));
    }
    if (!isEmpty(obj.category3)) {
      filteredFiles = filteredFiles.filter((file) => obj.category3.includes(file.devOrderId.catThreeId));
    }
    if (!isEmpty(obj.category4)) {
      filteredFiles = filteredFiles.filter((file) => obj.category4.includes(file.devOrderId.catFourId));
    }

    if (!isEmpty(obj.gradingGroups)) {
      filteredFiles = filteredFiles.filter((file) => obj.gradingGroups.some((groupId) => file.devOrderId.gradingGroups.includes(groupId)));
    }
    if (!isEmpty(obj.tags)) {
      filteredFiles = filteredFiles.filter((file) => file.tags.some((tg) => obj.tags.includes(tg.name)));
    }
    const updateFolderData = cloneFolderList?.map((folder) => {
      if (folder._id === folderId) {
        folder.productFiles = filteredFiles;
        return folder;
      }
      return folder;
    });

    setDamFolderState((prev) => ({ ...prev, damFolderList: updateFolderData }));
    await dispatch(action.filterDamFolderFilesSortData(obj));
    if (res) {
      const cloneObj = {
        loading: false,
      };
      await dispatch(action.filterDamFolderFilesSortData(cloneObj));
    }
  };

  const handleFilterClear = async () => {
    setIsApply(false);
    const sortinObj = {
      colourTheme: [],
      primaryColour: [],
      secondaryColour: [],
      folder: [],
      fileType: [],
      assetType: [],
      productType: [],
      brand: [],
      gradingGroups: [],
      category1: [],
      category2: [],
      category3: [],
      category4: [],
      dynamicDropdown: [],
      tags: [],
    };

    if (devOrderId) {
      sortinObj.devOrderId = devOrderId;
    }

    await dispatch(action.filterDamFolderFilesSortData(sortinObj));

    const res = {};

    setDamFolderState((prev) => ({ ...prev, damFolderList: damProductFolderList }));

    if (res) {
      const obj = {
        loading: false,
      };
      await dispatch(action.filterDamFolderFilesSortData(obj));
    }
  };

  return (
    <button type="button" title="Sort" className={isApply ? 'filter-btn filter-button_delete active' : 'filter-btn filter-button_delete'}>
      <OverlayTrigger
        placement="bottom"
        trigger="click"
        rootClose
        overlay={
          <Popover className="custom-popover popover-filter">
            <Popover.Content>
              <Row className="form-row">
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.FILE_Type')}</label>
                    <MultiSelect
                      name="group"
                      options={fileTypeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select file type"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val.value),
                          'fileType',
                        )
                      }
                      value={fileTypeOptions.filter((val) => !isEmpty(fileType) && fileType.includes(val.value))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.COLOR_THEME')}</label>
                    <MultiSelect
                      name="group"
                      options={colourThemeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select Brand"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'colourTheme',
                        )
                      }
                      value={colourThemeOptions.filter((val) => !isEmpty(colourTheme) && colourTheme.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.PRIMARY_COLOUR')}</label>
                    <MultiSelect
                      name="group"
                      options={colourThemeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select primary colour"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'primaryColour',
                        )
                      }
                      value={colourThemeOptions.filter((val) => !isEmpty(primaryColour) && primaryColour.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.SECONDARY_COLOUR')}</label>
                    <MultiSelect
                      name="group"
                      options={colourThemeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select secondary colour"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'secondaryColour',
                        )
                      }
                      value={colourThemeOptions.filter((val) => !isEmpty(secondaryColour) && secondaryColour.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row className="form-row">
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">Folder</label>
                    <MultiSelect
                      name="group"
                      options={folderOptionsList}
                      className="custom-multiselect w-100"
                      labelledBy="Select secondary colour"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'folder',
                        )
                      }
                      value={folderOptionsList.filter((val) => !isEmpty(folder) && folder.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.ASSET_TYPE')}</label>
                    <MultiSelect
                      name="group"
                      options={assetTypeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select asset type"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val.value),
                          'assetType',
                        )
                      }
                      value={assetTypeOptions.filter((val) => !isEmpty(assetType) && assetType.includes(val.value))}
                    />
                  </FormGroup>
                </Col>

                {dropdownOptions?.length > 0 &&
                  dropdownOptions?.map(
                    (dropdown) =>
                      dropdown?.isActive && (
                        <Col md={3} key={dropdown?._id}>
                          <FormGroup>
                            <label className="select-label">{dropdown?.keyName}</label>
                            <MultiSelect
                              name="group"
                              options={dropdown?.options || []}
                              className="custom-multiselect w-100"
                              labelledBy="Select dropdown"
                              onChange={(selected) =>
                                handleFilterDynamicSelect(
                                  selected.map((val) => val._id),
                                  dropdown?._id,
                                )
                              }
                              value={dropdown.options.filter((val) => checkArray(dropdown.options) && dynamicDropdown?.some((e) => e.valId === val._id))}
                            />
                          </FormGroup>
                        </Col>
                      ),
                  )}
              </Row>
              <Row className="form-row">
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.Product_Type')}</label>
                    <MultiSelect
                      name="group"
                      options={productTypeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select product type"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'productType',
                        )
                      }
                      value={productTypeOptions.filter((val) => !isEmpty(productType) && productType.includes(val._id))}
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.BRAND')}</label>
                    <MultiSelect
                      name="group"
                      options={brandOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select brand"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'brand',
                        )
                      }
                      value={brandOptions.filter((val) => !isEmpty(brand) && brand.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.CATEGORY_1')}</label>
                    <MultiSelect
                      name="group"
                      options={category1Options}
                      className="custom-multiselect w-100"
                      value={category1Options.filter((val) => !isEmpty(category1) && category1.includes(val._id))}
                      labelledBy={t('FILTER.SELECT_CATEGORY_ONE')}
                      overrideStrings={{
                        selectSomeItems: t('FILTER.SELECT_CATEGORY_ONE'),
                      }}
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'category1',
                        )
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.CATEGORY_2')}</label>
                    <MultiSelect
                      name="group"
                      options={category2Options}
                      className="custom-multiselect w-100"
                      value={category2Options.filter((val) => !isEmpty(category2) && category2.includes(val._id))}
                      labelledBy={t('FILTER.SELECT_CATEGORY_TWO')}
                      overrideStrings={{
                        selectSomeItems: t('FILTER.SELECT_CATEGORY_TWO'),
                      }}
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'category2',
                        )
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="form-row">
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.CATEGORY_3')}</label>
                    <MultiSelect
                      name="group"
                      options={category3Options}
                      className="custom-multiselect w-100"
                      value={category3Options.filter((val) => !isEmpty(category3) && category3.includes(val._id))}
                      labelledBy={t('FILTER.SELECT_CATEGORY_THREE')}
                      overrideStrings={{
                        selectSomeItems: t('FILTER.SELECT_CATEGORY_THREE'),
                      }}
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'category3',
                        )
                      }
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.CATEGORY_4')}</label>
                    <MultiSelect
                      name="group"
                      options={category4Options}
                      className="custom-multiselect w-100"
                      value={category4Options.filter((val) => !isEmpty(category4) && category4.includes(val._id))}
                      labelledBy={t('FILTER.SELECT_CATEGORY_FOUR')}
                      overrideStrings={{
                        selectSomeItems: t('FILTER.SELECT_CATEGORY_FOUR'),
                      }}
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'category4',
                        )
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.GRADING_GROUP')}</label>
                    <MultiSelect
                      name="group"
                      options={gradingGroupsOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select grading group"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'gradingGroups',
                        )
                      }
                      value={gradingGroupsOptions.filter((val) => !isEmpty(gradingGroups) && gradingGroups.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.TAGS')}</label>
                    <MultiSelect
                      name="group"
                      options={tagsList}
                      className="custom-multiselect w-100"
                      labelledBy="Select grading group"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val.name),
                          'tags',
                        )
                      }
                      value={tagsList.filter((val) => !isEmpty(tags) && tags.includes(val.name))}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-end">
                    <button onClick={() => handleFilterApply()} className="btn btn-default mr-2" type="button">
                      {t('DAM_MAIN_VIEW.LISTING_VIEW.APPLY')}
                    </button>
                    <button onClick={() => handleFilterClear()} className="btn btn-default" type="button">
                      {t('DAM_MAIN_VIEW.LISTING_VIEW.CLEAR')}
                    </button>
                  </div>
                </Col>
              </Row>
            </Popover.Content>
          </Popover>
        }
      >
        <i className="icon-filter" />
      </OverlayTrigger>
    </button>
  );
}

export default DamFolderFilesFilter;
